import { Component, OnInit } from "@angular/core";
import { Meta } from "@angular/platform-browser";
import { MatDialog } from "@angular/material/dialog";
import { SeoServiceService } from "src/app/services/seo-service.service";
import { VideoModalComponent } from "../../common/video-modal/video-modal.component";

@Component({
    selector: "app-k12",
    templateUrl: "./k12.component.html",
    styleUrls: ["./k12.component.scss"],
})
export class K12Component implements OnInit {

    constructor(private meta: Meta, private seoService: SeoServiceService, public dialog: MatDialog) { }

    ngOnInit(): void {
        this.seoService.createLinkForCanonicalURL();
        this.meta.addTag({
            name: "Description",
            content: "K-12 Digital Content - NCERT-Aligned Animated Content for Science, Maths, English, SST, and more.",
        });
    }

    openVideo(video: any) {
        if (video.videoId) {
            this.dialog.open(VideoModalComponent, {
                data: {
                    title: video.title,
                    video: `https://www.youtube.com/embed/${video.videoId}?autoplay=1`,
                    youtube: true,
                    vimeo: false,
                    discription: ''
                },
                panelClass: 'video-modal-panel'
            });
        }
    }

    subjects = [
        { icon: 'science', title: 'Science' },
        { icon: 'calculate', title: 'Maths' },
        { icon: 'menu_book', title: 'English' },
        { icon: 'public', title: 'SST' },
        { icon: 'biotech', title: 'Physics' },
        { icon: 'science', title: 'Chemistry' },
        { icon: 'emoji_nature', title: 'Biology' },
        { icon: 'more_horiz', title: 'More...' }
    ];

    demoVideos = [
        { title: 'K-12 01', videoId: 'VBlk3SYdx1s' },
        { title: 'K-12 02', videoId: '0o8tXY9Gtkw' },
        { title: 'K-12 03', videoId: 'W9xB66B4bWk' },
        { title: 'K-12 04', videoId: 'nCT1udyK12g' },
        { title: 'K-12 05', videoId: 'c_gXUtZwnps' },
        { title: 'K-12 06', videoId: 'N-SkHgDewUw' }
    ];

    learningOutcomes = [
        { icon: 'lightbulb', title: 'Concept Clarity', description: 'Deep understanding through visualization' },
        { icon: 'visibility', title: 'Visual Learning', description: 'Engaging animations for better grasp' },
        { icon: 'trending_up', title: 'Better Exam Results', description: 'Improved performance in assessments' },
        { icon: 'psychology', title: 'Improved Retention', description: 'Long-term memory of concepts' }
    ];
}
